import { createFileRoute } from "@tanstack/react-router";
import { CreditHistoryPage } from "@/pages/credit-history";

export const Route = createFileRoute(
  "/_authed/$companySlug/_settings/settings/subscription/credit-history",
)({
  component: CreditHistoryPage,
});
